import { render, staticRenderFns } from "./AddTruckModal.vue?vue&type=template&id=162574e6&"
import script from "./AddTruckModal.vue?vue&type=script&lang=js&"
export * from "./AddTruckModal.vue?vue&type=script&lang=js&"
import style0 from "./AddTruckModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports